import { Row, Col, Form } from 'react-bootstrap'
import objectPath from 'object-path'
import FeatherIcon from 'feather-icons-react'
import { Remove, TrendingDown, TrendingUp } from '@mui/icons-material'
import { useMemo } from 'react'
import NumberFormat from 'react-number-format'
import { toMetric } from 'designer/component/action/Data'

const Count = (props) => {
  const { chart, dataSource } = props
  const height = objectPath.get(chart, 'chart.height')
  const icon = objectPath.get(chart, 'options.icon') || {}
  const title = objectPath.get(chart, 'options.title') || {}
  const count = objectPath.get(chart, 'options.count') || {}
  const value = objectPath.get(chart, 'value')
  const percent = objectPath.get(chart, 'percent')
  const { percentKey, metricNumber, thousandSeparator } = dataSource || {}

  const countValue = useMemo(() => {
    if (metricNumber) {
      return toMetric(value)
    }
    if (thousandSeparator) {
      return (
        <NumberFormat
          name="value"
          thousandSeparator={thousandSeparator}
          value={parseFloat(Number(value).toFixed(2))}
          readOnly={true}
        />
      )
    }
    return value || 0
  }, [value])

  return (
    <Row
      className="w-100 mb-0 d-flex align-items-center p-3"
      style={{ minHeight: height, height: 'auto' }}
    >
      <Col sm="" className="px-0">
        <p
          className="mb-0 d-flex justify-content-start"
          style={{ fontSize: title?.size, color: title?.color }}
        >
          {title?.content}
        </p>
        <h2
          className="mb-0 d-flex justify-content-left"
          style={{ fontSize: count?.size, color: count?.color }}
        >
          <Row>
            <Col xs="auto" sm="auto">
              {countValue}
            </Col>
            {percent !== undefined && percentKey && (
              <Col xs="auto" sm="auto" className="px-0">
                <Row className="w-100 mx-auto d-flex justify-items-center">
                  {percent === 0 ? (
                    <Remove />
                  ) : percent > 0 ? (
                    <TrendingUp />
                  ) : (
                    <TrendingDown />
                  )}
                </Row>
                <Row className="w-100 mx-auto d-flex justify-items-center">
                  <Form.Label className="mb-0 " style={{ fontSize: '14px' }}>
                    {percent}%
                  </Form.Label>
                </Row>
              </Col>
            )}
          </Row>
        </h2>
      </Col>
      {icon?.name && (
        <Col xs="auto" sm="auto" className="d-flex align-items-content">
          <span
            className="p-3"
            style={{
              border: `1px solid ${icon?.color}`,
              borderRadius: '50%',
            }}
          >
            {icon?.source === 'ckd' && (
              <i
                className={`ckd-icon ckd-${icon?.name} d-flex justify-content-center`}
                style={{
                  color: icon?.color,
                  margin: 0,
                  fontSize: icon?.size,
                  width: icon?.size,
                  height: icon?.size,
                }}
              ></i>
            )}
            {icon?.source === 'feather' && (
              <FeatherIcon
                className="d-flex justify-content-center"
                style={{
                  fontSize: icon?.size,
                  color: icon?.color,
                  width: icon?.size,
                  height: icon?.size,
                }}
                icon={icon?.name}
                size={icon?.size}
              />
            )}
            {icon?.source === 'fas' && (
              <i
                className={`fas fa-${icon?.name} d-flex justify-content-center`}
                style={{
                  fontSize: icon?.size,
                  color: icon?.color,
                  width: icon?.size,
                  height: icon?.size,
                }}
              />
            )}
            {icon?.source === 'char' && (
              <i
                className="ck-badge d-flex justify-content-center"
                style={{
                  backgroundColor: icon?.bgColor,
                  color: icon?.color,
                  fontSize: icon?.size,
                  textAlign: 'center',
                  width: icon?.size,
                  height: icon?.size,
                }}
              >
                {icon?.content}
              </i>
            )}
          </span>
        </Col>
      )}
    </Row>
  )
}

export default Count
